/**
 * The two number formats the admin UI ships: English (`22,567.5`) and European
 * (`22 567,5`), the latter borrowed from `nb`. The browser language picks between
 * them, not the chosen UI language.
 */
export type AppLocale = 'en' | 'nb';

/**
 * Formatting locale for every number and date in the app. `LOCALE_ID` is provided
 * from this, so the `number` pipe follows it; the few non-DI call sites (ag-grid
 * value formatters) call it directly to stay in step.
 */
export function resolveAppLocale(): AppLocale {
  const browserLocale =
    globalThis.navigator?.languages?.[0]?.toLowerCase() ??
    globalThis.navigator?.language?.toLowerCase();

  return browserLocale?.startsWith('en') ? 'en' : 'nb';
}
